import { render, staticRenderFns } from "./NotificationPanelItemLabel.vue?vue&type=template&id=19783729&scoped=true"
import script from "./NotificationPanelItemLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationPanelItemLabel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationPanelItemLabel.vue?vue&type=style&index=0&id=19783729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19783729",
  null
  
)

export default component.exports